import { ListboxOption, type ListboxOptionProps } from "./ListboxOption";

export type ListboxPlaceholderProps<T> = Omit<
  ListboxOptionProps<T>,
  "value"
> & { value?: T };

export function ListboxPlaceholder<TType = string>({
  children,
  value,
  ...props
}: ListboxPlaceholderProps<TType>) {
  return (
    <ListboxOption data-slot="placeholder" value={value ?? ""} {...props}>
      {children}
    </ListboxOption>
  );
}
